import React, { Component } from "react";
import { connect } from "react-redux";
import {
  LIST_PAGE_SIZES,
  DASHBOARD_SLIDES_STATUS,
  SPECIAL_CARACTERES
} from "Config";
import debounce from "lodash.debounce";
import styles from "./Item.local.scss";

import {
  setDashboardListFilterTitle,
  setDashboardListPaginationPage,
  setDashboardListPageSize,
  setDashboardListFilterJuridicalForm,
  setDashboardListFilterisPublic
} from "actions";
import DashboardActions from "./DashboardActions";
import { fetchDasboardJuridicalFormSuggestions } from "thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import _ from "i18n";

class DashboardFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabsOptions: DASHBOARD_SLIDES_STATUS,
      statusLibrary: false,
      statusMyTemplate: false,
      libraryDashboardsStatus: [],
      myTemplateDashboardsStatus: []
    };

    this.loadJuridicalFormSuggestions = debounce(
      this.loadJuridicalFormSuggestions,
      1000
    );
  }
  componentDidMount() {
    if (this.props.selectedStates.includes("ALL")) {
      this.props.dispatch(setDashboardListFilterisPublic("", ""));
    }
    this.state.libraryDashboardsStatus.map((item, i) => {
      if (item.value === "SHARED") {
        this.state.libraryDashboardsStatus.splice(0, 2);
      }
    });
    this.state.myTemplateDashboardsStatus.map((item, i) => {
      if (item.value === "CREATED") {
        this.state.myTemplateDashboardsStatus.splice(0, 2);
      }
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.statusCounts !== this.props.statusCounts) {
      /**************** Library filter push ********** *****/
      if (
        this.props.selectedStates.includes("LIBRARY") &&
        !this.state.statusLibrary
      ) {
        this.state.libraryDashboardsStatus.push(
          { label: _("standard"), value: "STANDARD" },
          { label: _("share"), value: "SHARED" }
        );
        this.setState({
          statusLibrary: true
        });
      }
      /**************** My template filter push ********** *****/
      if (
        this.props.selectedStates.includes("MyTemplates") &&
        !this.state.statusMyTemplate
      ) {
        this.state.myTemplateDashboardsStatus.push(
          { label: _("private"), value: "CREATED" },
          { label: _("public"), value: "Templates" }
        );
        this.setState({
          statusMyTemplate: true
        });
      }
      /**************** Remove children of my template and library isSelectedState is ALL ********** *****/
      if (
        (this.state.statusMyTemplate === true ||
          this.state.statusLibrary === true) &&
        this.props.selectedStates.includes("ALL")
      ) {
        this.state.myTemplateDashboardsStatus.splice(0, 2);
        this.state.libraryDashboardsStatus.splice(0, 2);

        this.setState({
          statusLibrary: false,
          statusMyTemplate: false
        });
      }
      /**************** Remove children of my template isSelectedState is Library  ********** *****/
      if (
        this.state.statusMyTemplate === true &&
        this.props.selectedStates.includes("LIBRARY")
      ) {
        this.state.myTemplateDashboardsStatus.splice(0, 2);
        this.setState({
          statusMyTemplate: false
        });
      }

      let tabsOptions = DASHBOARD_SLIDES_STATUS.map(({ label, value }) => {
        let countsCreatedDshboard = parseInt(this.props.statusCounts["CREATED"])
          ? parseInt(this.props.statusCounts["CREATED"])
          : 0;
        return {
          label: label,
          value: value,
          count:
            value === "LIBRARY"
              ? parseInt(this.props.statusCounts["STANDARD"]) +
                parseInt(this.props.statusCounts["SHARED"])
              : value === "MyTemplates"
                ? countsCreatedDshboard +
                  parseInt(this.props.statusCounts["Templates"])
                : this.props.statusCounts[value]
        };
      });

      let libraryDashboardsStatus = this.state.libraryDashboardsStatus.map(
        ({ label, value }) => {
          return {
            label: label,
            value: value,
            count: this.props.statusCounts[value]
          };
        }
      );
      let myTemplateDashboardsStatus = this.state.myTemplateDashboardsStatus.map(
        ({ label, value }) => {
          return {
            label: label,
            value: value,
            count: this.props.statusCounts[value]
              ? this.props.statusCounts[value]
              : 0
          };
        }
      );
      this.setState({
        tabsOptions: tabsOptions,
        libraryDashboardsStatus: libraryDashboardsStatus,
        myTemplateDashboardsStatus: myTemplateDashboardsStatus
      });

      if (this.state.myTemplateDashboardsStatus.length > 0) {
        libraryDashboardsStatus = myTemplateDashboardsStatus;
      }
      this.props.handleChangeDashboardsStatus(libraryDashboardsStatus);
    }
  }
  handleConvertAccentToCode(word) {
    SPECIAL_CARACTERES.map(item => {
      for (var i = 0; i < word.length; i++) {
        if (word[i] === item.letter) {
          if (i === 0) {
            word = this.setCharAt(word, i, item.code);
          } else {
            word = this.setCharAt(word, i, "\\" + item.code);
          }
        }
      }
    });
    return word;
  }
  setCharAt(str, index, char) {
    return str.substring(0, index) + char + str.substring(index + 1);
  }
  handleSearchInputChange(word) {
    let convertedCaractere = this.handleConvertAccentToCode(word);
    if (word.length > 2 || word.length === 0) {
      this.props.dispatch(setDashboardListFilterTitle(convertedCaractere));
    }
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    this.props.dispatch(setDashboardListPaginationPage(LIST_PAGE_SIZES[0]));
  };
  handleDashboardListPageSizeChange = selected => {
    this.props.dispatch(setDashboardListPageSize(selected));
  };

  handleJuridicalFormChange = selected => {
    this.props.dispatch(setDashboardListFilterJuridicalForm(selected));
  };

  loadJuridicalFormSuggestions = (searchWord, callback) => {
    let { lng } = this.props;
    lng = lng.charAt(0).toUpperCase() + lng.slice(1);
    this.props
      .dispatch(fetchDasboardJuridicalFormSuggestions({ searchWord, lng }))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return {
            value: t["short" + lng],
            label: t["label" + lng],
            color: "#000000"
          };
        });
        callback(categories);
      })
      .catch(er => {
        callback([]);
      });
  };

  handleOnClickTabFilter = value => {
    this.props.onTabChange(value);
  };

  render() {
    let {
      dashboardsFilter,
      pageSize,
      selectedStates,
      backOffice,
      isDashboardTemplateFrame
    } = this.props;
    let { tabsOptions } = this.state;

    let asyncFilters = [
      {
        placeholder: _("juridicalForm"),
        handleChange: this.handleJuridicalFormChange,
        loadSuggestions: this.loadJuridicalFormSuggestions,
        value: dashboardsFilter.juridicalForms
      }
    ];

    return (
      <div className="row align-center medium-11">
        <div className={`medium-12 ${styles.filter_bar}`}>
          <DashboardActions />
          <TTPFilterHorizontalBar
            tabs={backOffice ? [] : tabsOptions}
            selectedTab={selectedStates}
            asyncFilters={asyncFilters}
            onTabChange={this.handleOnClickTabFilter}
            searchInputValue={dashboardsFilter.name}
            searchPlaceholder={_("searchByDashboardName")}
            pageSize={isDashboardTemplateFrame === false && pageSize}
            handleResetFilter={this.handleResetFilter}
            handleListPageSizeChange={this.handleDashboardListPageSizeChange}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
            HideButton={isDashboardTemplateFrame}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  dashboardsFilter: state.dashboardList.filter,
  pageSize: state.dashboardList.pageSize,
  lng: state.params.lng,
  backOffice: state.params.backOffice,
  statusCounts: state.dashboardList.statusCounts
});

export default connect(mapStateToProps)(DashboardFilter);



// WEBPACK FOOTER //
// ./src/components/DashboardList/DashboardFilter.js